<template>
    <div class="imgChooser has-text-centered has-background-dark">
       <div class="has-background-coolGreen">
           <i class="fa fa-image"></i>
       </div>
       <div class="bottom10">
           <div class="is-size-7"><b>This site does not provide a default image, but you can choose from the following images found within in it.</b> </div>
           <div class="is-size-7">(If you don't make a choice, the first image will be used)</div>
       </div>
       <div v-for="(item, i) in images" :key="i" class="is-inline-block imgChooserImg handCursor" :class="{borderRight: i%2 == 0}" @click="select(item)">
           <img :src="item" />
       </div>
    </div>
</template>

<script>

export default{
    props: {
        images: {
            type: Array,
            default: []
        }
    },
    data: function(){
        return {

        }
    },

    methods: {
        select: function(img){
            this.$parent.selectImg(img)
        }
    }
}

</script>